import { useState } from 'react';
import PageGridAlt from '../Components/PageGridAlt';
import useFetch from '../Hooks/useFetch';
import {GrCaretNext, GrCaretPrevious} from 'react-icons/gr';
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from 'react-redux';
import {TiTimes} from 'react-icons/ti';
import {IoIosArrowDown} from 'react-icons/io';
import useGroup from '../Hooks/useGroup';

const Movies = ()=>{
    const key  = process.env.REACT_APP_API_KEY;
    const [page,setPage] = useState(1);
    const [gridFilter,setGridFilter] = useState('popularity.desc')
    const {results:movies} = useFetch(`https://api.themoviedb.org/3/discover/movie?api_key=${key}&language=en-US&sort_by=${gridFilter}&include_adult=false&include_video=false&page=${page}&with_watch_monetization_types=flatrate`);

    const show = useSelector(state=>state.ShowReducer);
    const dispatch = useDispatch();
    const {col,space} = useGroup();

    const handlePage = (e)=>{
        if(e.target.innerText==='Next'){
            setPage(state=>state+1);
        }
        else{
            if(page===1){
                setPage(1);
            }
            setPage(state=>state-1);
        }
    }
    const handleFilter = (e)=>{
        setGridFilter(e.target.innerText.toLowerCase())
    }
    const handleShow = ()=>{
        dispatch({type:'FILTER',payload:!show})
    }
    return <div className="dark:bg-secondary-dark min-h-screen pt-12 pb-2 ">
        <div className={`px-2 md:px-4 lg:px-8`}>

            <section className="flex flex-col justify-center">
                <button className="text-headline dark:text-headline-dark font-heading lg:text-lg md:text-md text-sm flex flex-row items-center justify-center" onClick={handleShow}>Filter{(show)?<TiTimes/>:<IoIosArrowDown/>}</button>
                <span className={`text-headline dark:text-headline-dark font-heading lg:text-md md:text-sm text-[0.45rem] border-2 p-4 border-stroke ${(show)?'block':'hidden'}`}>
                    <Swiper
                        slidesPerView={col}
                        spaceBetween={space}
                        slidesPerGroup={col}
                    >
                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='popularity.asc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Popularity.Asc</button>
                        </SwiperSlide>

                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='popularity.desc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Popularity.Desc</button>
                        </SwiperSlide>

                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='release_date.asc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Release_Date.Asc</button>
                        </SwiperSlide>

                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='release_date.desc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Release_Date.Desc</button>
                        </SwiperSlide>

                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='revenue.asc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Revenue.Asc</button>
                        </SwiperSlide>
                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='revenue.desc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Revenue.Desc</button>
                        </SwiperSlide>

                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='title.asc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Title.Asc</button>
                        </SwiperSlide>
                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='title.desc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Title.Desc</button>
                        </SwiperSlide>

                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='rating.asc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Rating.Asc</button>
                        </SwiperSlide>
                        
                        <SwiperSlide>
                            <button onClick={handleFilter} className={`${(gridFilter==='rating.desc')?'text-tertiary-dark':'text-headline dark:text-headline-dark'}`}>Rating.Desc</button>
                        </SwiperSlide>
                    </Swiper>
                </span>
                <h4 className={`text-xs text-[red] text-center font-body ${(show)?'block':'hidden'}`}>Slide for more</h4>
            </section>
        </div>
        {
            (movies)?
            <PageGridAlt data={movies}/>
            :
            null
        }
        <section className='flex flex-row justify-center lg:text-lg md:text-md text-sm text-button-text mt-4'>
            <button className='bg-button dark:bg-button-dark mr-2 px-4 py-1 flex flex-row items-center' onClick={handlePage}><GrCaretPrevious/>Prev</button>
            <button className='bg-button dark:bg-button-dark ml-2 px-4 py-1 flex flex-row items-center' onClick={handlePage}>Next<GrCaretNext/></button>
        </section>
    </div>
}

export default Movies;